import { createClient, type SupabaseClient } from '@supabase/supabase-js';

import { env, isSupabaseConfigured } from '@/config/env';
import type { Database } from '@/types/database.generated';

/**
 * Единственный клиент Supabase на приложение.
 *
 * `null`, когда окружение не настроено: `createClient('', '')` бросает
 * исключение при вызове, а приложение обязано запускаться и без Supabase
 * (см. src/config/env.ts) — белого экрана из-за отсутствующего .env быть
 * не должно.
 */
export const supabase: SupabaseClient<Database> | null = isSupabaseConfigured
  ? createClient<Database>(env.VITE_SUPABASE_URL, env.VITE_SUPABASE_ANON_KEY, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: false,
      },
    })
  : null;
